<!-- <div class="wrapper">
    <div class="loading">
        <img src="assets/diamond_img/loading.gif" alt="" class="mCS_img_loaded">
    </div>
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-md-10 report-main-content m-t-5">
                    <div class="card">
                        <div class="card-header">
                          <h4 class="mb-0">Change Password</h4>
                        </div>
                        <div class="card-body container-fluid container-fluid-5">
                            <div class="row row5 mt-2">
                                <div class="col-md-4 col-12">
                                    <form [formGroup]='changePasswordForm' (ngSubmit)='onSubmitChangePassword()'>
                                        <div class="form-group mb-3">
                                            <label class="mb-1">Current Password <span class="asterisk_input"></span></label>
                                            <input type="password" class="form-control" formControlName='old_password'>
                                        </div>
                                        <div class="form-group mb-3">
                                            <label class="mb-1">New Password <span class="asterisk_input"></span></label>
                                            <input type="password" class="form-control" formControlName='new_password'>
                                        </div>
                                        <div class="form-group">
                                            <label class="mb-1">Confirm New Password <span class="asterisk_input"></span></label>
                                            <input type="password" class="form-control" formControlName='confirm_password'>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="row row5 mt-2">
                                <div class="col-12">
                                    <button type="submit" class="btn btn-primary" (click)="onSubmitChangePassword()">Change Password</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>  -->

  <div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                    <!-- <ul class="nav nav-tabs sport-tab">
                        <li class="nav-item"><a class="nav-link active" (click)="goToAll('All')">Home</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="inplay()">In-Play</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="multi()">Multi Markets</a></li>
                        <li class="nav-item" *ngFor="let sports of allSportsList;let i= index"
                          (click)="goToDashboard(sports.name,sports.sport_id,sports)"><a class="nav-link"
                            [ngClass]="{'newlaunch':sports.sport_id <= -100 }">{{sports.name}}</a></li>
                    </ul> -->
                </div>

                <!-- <div class="col-md-12 ">
                  <div class="listing-grid">
                      <div class="detail-row">
                          <h2>Change Password</h2>
                      </div>
                      <div class="row m-t-20">
                          <div class="col-md-12">
                            <form [formGroup]='changePasswordForm' (ngSubmit)='onSubmitChangePassword()'>
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>Old Password</label>
                                    <input type="password" class="form-control password-box"
                                      formControlName='old_password'>
                                    <div *ngIf="submitted && f.old_password.errors">
                                      <div *ngIf="f.old_password.errors.required" class="red-message">Old password is required</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>New Password</label>
                                    <input type="password" class="form-control password-box"
                                      formControlName='new_password'>
                                    <div *ngIf="submitted && f.new_password.errors">
                                      <div *ngIf="f.new_password.errors.required" class="red-message">New password is required</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>Confirm Password</label>
                                    <input type="password" class="form-control password-box"
                                      formControlName='confirm_password'>
                                    <div *ngIf="submitted && f.confirm_password.errors">
                                      <div *ngIf="f.confirm_password.errors.required" class="red-message">Confirm password is required</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-4">
                                  <label>&nbsp;</label><br>
                                  <button type="submit" class="btn btn-diamond">Load</button>
                                </div>
                              </div>
                  
                            </form>
                          </div>
                      </div>
                      
                  </div>
              </div> -->
              <div class="col-md-10 report-main-content m-t-5">
                <div class="card">
                  <div class="card-header"><h4 class="mb-0">Change Password</h4></div>
                  <div class="card-body container-fluid container-fluid-5">
                    <div class="row row5 mt-2">
                      <div class="col-md-12">
                        <form [formGroup]='changePasswordForm' (ngSubmit)='onSubmitChangePassword()'>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Old Password</label>
                                <input [type]="showOldPassword ? 'text' : 'password'" class="form-control password-box"
                                  formControlName='old_password'>
                                  <div>
                                    <i alt="show" class="fa fa-eye eye-show"
                                        (click)="showOldPassword = !showOldPassword"
                                        [class.hide]="showOldPassword"></i>
                                    <i alt="hide" class="fa fa-eye-slash eye-hide"
                                        (click)="showOldPassword = !showOldPassword"
                                        [class.hide]="!showOldPassword"></i>
                                </div>
                                <div *ngIf="submitted && f.old_password.errors">
                                  <div *ngIf="f.old_password.errors.required" class="red-message">Old password is required</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>New Password</label>
                                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control password-box"
                                  formControlName='new_password'>
                                  <div>
                                    <i alt="show" class="fa fa-eye eye-show"
                                        (click)="showNewPassword = !showNewPassword"
                                        [class.hide]="showNewPassword"></i>
                                    <i alt="hide" class="fa fa-eye-slash eye-hide"
                                        (click)="showNewPassword = !showNewPassword"
                                        [class.hide]="!showNewPassword"></i>
                                </div>
                                <div *ngIf="submitted && f.new_password.errors">
                                  <div *ngIf="f.new_password.errors.required" class="red-message">New password is required</div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Confirm Password</label>
                                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control password-box"
                                  formControlName='confirm_password'>
                                  <div>
                                    <i alt="show" class="fa fa-eye eye-show"
                                        (click)="showConfirmPassword = !showConfirmPassword"
                                        [class.hide]="showConfirmPassword"></i>
                                    <i alt="hide" class="fa fa-eye-slash eye-hide"
                                        (click)="showConfirmPassword = !showConfirmPassword"
                                        [class.hide]="!showConfirmPassword"></i>
                                </div>
                                <div *ngIf="submitted && f.confirm_password.errors">
                                  <div *ngIf="f.confirm_password.errors.required" class="red-message">Confirm password is required</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <label>&nbsp;</label><br>
                              <button type="submit" class="btn btn-primary">Load</button>
                            </div>
                          </div>
              
                        </form>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
